import { useEventListener } from '@deltasierra/react-hooks';
import * as React from 'react';
import { guessDate } from './guess-date';

export function useDateInput(
    ref: React.RefObject<HTMLInputElement>,
    value?: Date,
    onChange?: (value?: Date) => void,
    options?: { region: string },
): [string, React.Dispatch<React.SetStateAction<string>>] {
    const [displayValue, setDisplayValue] = React.useState('');
    const { region = 'en-au' } = options ?? {};
    const fmt = React.useMemo(() => Intl.DateTimeFormat(region), [region]);

    const onChangeRef = React.useRef(onChange);
    React.useEffect(() => {
        onChangeRef.current = onChange;
    }, [onChange]);

    const validateDisplayValue = React.useCallback((val: string) => {
        onChangeRef.current?.(guessDate(val));
    }, []);

    useEventListener('blur', () => validateDisplayValue(displayValue), ref);
    useEventListener('keydown', ev => ev.key === 'Enter' && validateDisplayValue(displayValue), ref);

    React.useEffect(() => {
        if (value) {
            setDisplayValue(fmt.format(value));
        }
    }, [value, fmt]);

    return [displayValue, setDisplayValue];
}
